export enum AnthropicModels {
  CLAUDE_3_5_SONNET = "claude-3-5-sonnet-latest",
  CLAUDE_3_7_SONNET = "claude-3-7-sonnet-latest",
  CLAUDE_3_5_HAIKU = "claude-3-5-haiku-latest",
  CLAUDE_3_OPUS_LATEST = "claude-3-opus-latest",
}

export const AnthropicModelsEnabled = [AnthropicModels.CLAUDE_3_5_HAIKU, AnthropicModels.CLAUDE_3_5_SONNET, AnthropicModels.CLAUDE_3_7_SONNET]
